// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientPhoneModel {
    static getAttributeTypeMap() {
        return PatientPhoneModel.attributeTypeMap;
    }
}
PatientPhoneModel.discriminator = undefined;
PatientPhoneModel.additionalProperties = false;
PatientPhoneModel.attributeTypeMap = [
    {
        "name": "phoneId",
        "baseName": "phoneId",
        "type": "number"
    },
    {
        "name": "phoneType",
        "baseName": "phoneType",
        "type": "PatientPhoneContactInformationType"
    },
    {
        "name": "phonePurpose",
        "baseName": "phonePurpose",
        "type": "PatientContactInformationPurposeType"
    },
    {
        "name": "phoneNumber",
        "baseName": "phoneNumber",
        "type": "string"
    },
    {
        "name": "extension",
        "baseName": "extension",
        "type": "string"
    },
    {
        "name": "contactDatePreferenceType",
        "baseName": "contactDatePreferenceType",
        "type": "PatientContactDatePreferenceType"
    },
    {
        "name": "bestDaysToCall",
        "baseName": "bestDaysToCall",
        "type": "string"
    },
    {
        "name": "contactTimePreferenceType",
        "baseName": "contactTimePreferenceType",
        "type": "PatientContactTimePreferenceType"
    },
    {
        "name": "bestTimeToCall",
        "baseName": "bestTimeToCall",
        "type": "string"
    },
    {
        "name": "language",
        "baseName": "language",
        "type": "string"
    },
    {
        "name": "timeZone",
        "baseName": "timeZone",
        "type": "string"
    },
];
//# sourceMappingURL=patientPhoneModel.js.map